import { render, staticRenderFns } from "./RbuSectionItemMappingPaginatedList.vue?vue&type=template&id=700c3f8c&scoped=true"
import script from "./RbuSectionItemMappingPaginatedList.vue?vue&type=script&lang=js"
export * from "./RbuSectionItemMappingPaginatedList.vue?vue&type=script&lang=js"
import style0 from "./RbuSectionItemMappingPaginatedList.vue?vue&type=style&index=0&id=700c3f8c&prod&lang=less"
import style1 from "./RbuSectionItemMappingPaginatedList.vue?vue&type=style&index=1&id=700c3f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c3f8c",
  null
  
)

export default component.exports